<template>
  <div>
    <v-row>
      <v-col cols="6">
        <span>{{ getTitle }}</span>
        <v-select
          outlined
          item-text="title"
          item-value="value"
          :disabled="loadingData"
          :loading="loading"
          :items="$options.kioskBannerType"
          :value="bannerType"
          :error-messages="errorBannerType"
          @change="$emit('banner-type-change', $event)"
        />
      </v-col>
    </v-row>
    <v-row v-if="getTypeBanner">
      <v-col v-if="getTypeBanner === 'image'" cols="6">
        <MediaFilePicker
          :label="'Изображение'"
          :multiple="false"
          :file-type="$options.mediaTypesByKeys.IMAGE"
          :value="returnImageBannerId"
          @change="changeBanner($event)"
        />
      </v-col>
      <v-col v-if="getTypeBanner === 'video'" cols="6">
        <MediaFilePicker
          :label="'Видео'"
          :multiple="false"
          :file-type="$options.mediaTypesByKeys.VIDEO"
          :value="returnVideoBannerId"
          @change="changeBanner($event)"
        />
      </v-col>
      <v-col v-if="getTypeBanner === 'url'" cols="6">
        <span>url</span>
        <v-text-field
          outlined
          placeholder="https://"
          :disabled="loadingData"
          :loading="loading"
          :value="returnUrlBanner"
          @input="changeBanner($event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import kioskBannerType from '@/configs/kioskBannerType'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'

import MediaFilePicker from '@/components/media-file-picker'

export default {
  name: 'FormKioskBannerType',
  kioskBannerType,
  mediaTypesByKeys: mediaTypesByKeys(),
  components: {
    MediaFilePicker
  },
  props: {
    title: {
      type: String,
      default: 'Тип рекламного баннера'
    },
    requiredField: {
      type: Boolean,
      default: false
    },
    loadingData: {
      type: Boolean,
      default: false
    },
    bannerType: {
      type: String,
      default: 'NONE'
    },
    content: {
      type: Object,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorBannerType: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getTitle () {
      return this.requiredField ? `${this.title} *` : this.title
    },
    getTypeBanner () {
      switch (this.bannerType) {
        case 'IMAGE':
          return 'image'
        case 'VIDEO':
          return 'video'
        case 'URL':
          return 'url'
        default:
          return false
      }
    },
    returnImageBannerId () {
      return this.content?.imageBannerId || null
    },
    returnVideoBannerId () {
      return this.content?.videoBannerId || null
    },
    returnUrlBanner () {
      return this.content?.urlBanner || null
    }
  },
  methods: {
    changeBanner (value) {
      switch (this.bannerType) {
        case 'IMAGE':
          this.$emit('update-content', {
            imageBannerId: value
          })
          break
        case 'VIDEO':
          this.$emit('update-content', {
            videoBannerId: value
          })
          break
        case 'URL':
          this.$emit('update-content', {
            urlBanner: value
          })
          break
        default:
          this.$emit('update-content', {})
          break
      }
    }
  }
}
</script>

<style>
</style>
